import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormCheck,
} from "@coreui/react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { getProfile, updateProfile } from "src/services/profile.services";
import { uploadImage } from "src/services/util.services";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import toast from "react-hot-toast";
import { useData } from "../../context/DataContext";

const schema = z.object({
  userType: z.string().nonempty("Please select user type"),
  designation: z.string().optional(),
  avatar: z.string().optional(),
  firstName: z.string().min(1, "Please type first name"),
  lastName: z.string().min(1, "Please type last name"),
  employeeCode: z.string().min(1, "Please type employee code"),
  email: z
    .string()
    .min(1, "Please type email")
    .email("This is not a valid email."),
});

const UserProfile = () => {
  const defaultErrorMessage = "Something went wrong";
  const { userData, setUserData } = useData();
  const [userInfo, setUserInfo] = useState(null);
  const [userImage, setUserImage] = useState(null);
  const fileInput = useRef(null);

  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = (id) => {
    // setIsLoading(true)
    getProfile()
      .then(async (response) => {
        setUserInfo(response.data);
        const {
          userType,
          designation,
          email,
          firstName,
          lastName,
          employeeCode,
          avatar,
        } = response.data;
        setValue("userType", userType._id);
        setValue("designation", designation ? designation : "");
        setValue("email", email);
        setValue("firstName", firstName);
        setValue("lastName", lastName);
        setValue("employeeCode", employeeCode);
        setValue("avatar", avatar ? avatar : "");
        setUserImage(avatar);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      userType: "",
      designation: "",
      email: "",
      firstName: "",
      lastName: "",
      employeeCode: "",
      avatar: "",
    },
    resolver: zodResolver(schema),
  });

  const onSubmit = (data) => {
    toast
      .promise(
        updateProfile(data),
        {
          loading: "Loading",
          success: "Profile Updated Succesfully",
          error: (err) => {
            return err.response &&
              err.response.data &&
              err.response.data.message
              ? err.response.data.message
              : defaultErrorMessage;
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        const updatedData = response.data;
        setUserInfo(response.data);
        const storageUserObj = {
          id: updatedData._id,
          avatar: updatedData.avatar,
          createdAt: updatedData.createdAt,
          email: updatedData.email,
          firstName: updatedData.firstName,
          lastName: updatedData.lastName,
          permission: updatedData.userType.permission,
          userType: updatedData.userType.type,
          position: updatedData.userType.name,
          country: updatedData.country,
        };
        if (updatedData.location) {
          storageUserObj.location = updatedData.location;
        }

        setUserData(storageUserObj);
        console.log("response", response);
      })
      .catch((error) => console.error(error));
  };

  const onError = (err) => {
    console.error(err);
  };

  const triggerFileUpload = () => {
    fileInput.current.click();
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    toast
      .promise(
        uploadImage(formData, config),
        {
          loading: "Loading",
          success: "Image added Succesfully",
          error: (err) => {
            console.log(err);
            return "Something went wrong. Please upload again";
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        console.log("response", response);
        setValue("avatar", response.url);
        setUserImage(response.url);
      })
      .catch((error) => console.error(error));
  };

  return (
    <CForm onSubmit={handleSubmit(onSubmit, onError)}>
      <div className="row gutters-sm">
        <div className="col-md-4 mb-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex flex-column align-items-center text-center">
                <CFormInput
                  hidden
                  type="file"
                  accept="image/*"
                  onChange={handleFileUpload}
                  ref={fileInput}
                />
                <img
                  onClick={triggerFileUpload}
                  style={{ cursor: "pointer" }}
                  src={userImage ? userImage : demoAvatar}
                  alt="Admin"
                  className="rounded-circle"
                  width="150"
                />
                <div className="mt-3">
                  <h4>
                    {userInfo?.firstName} {userInfo?.lastName}
                  </h4>
                  <p className="text-secondary mb-1">{userInfo?.designation}</p>
                  <p className="text-muted font-size-sm">
                    {userInfo?.userType.name}
                  </p>
                  {/* <button className="btn btn-primary">Follow</button>
                      <button className="btn btn-outline-primary">Message</button> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="card mt-3">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-globe mr-2 icon-inline"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>Website</h6>
                    <span className="text-secondary">https://bootdey.com</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-github mr-2 icon-inline"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>Github</h6>
                    <span className="text-secondary">bootdey</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-twitter mr-2 icon-inline text-info"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>Twitter</h6>
                    <span className="text-secondary">@bootdey</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-instagram mr-2 icon-inline text-danger"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>Instagram</h6>
                    <span className="text-secondary">bootdey</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-facebook mr-2 icon-inline text-primary"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>Facebook</h6>
                    <span className="text-secondary">bootdey</span>
                  </li>
                </ul>
              </div> */}
        </div>
        <div className="col-md-8">
          <div className="card mb-3">
            <div className="card-body">
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="firstName"
                  className="col-sm-3 col-form-label"
                >
                  First Name:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="firstName"
                    {...register("firstName")}
                  />
                  {errors.firstName?.message && (
                    <p className="error_text">{errors.firstName?.message}</p>
                  )}
                </CCol>
              </CRow>
              {/* <hr/> */}
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="lastName"
                  className="col-sm-3 col-form-label"
                >
                  Last Name:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="lastName"
                    {...register("lastName")}
                  />
                  {errors.lastName?.message && (
                    <p className="error_text">{errors.lastName?.message}</p>
                  )}
                </CCol>
              </CRow>
              {/* <hr/> */}
              <CRow className="mb-3">
                <CFormLabel htmlFor="email" className="col-sm-3 col-form-label">
                  Email:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="email"
                    id="email"
                    {...register("email")}
                  />
                  {errors.email?.message && (
                    <p className="error_text">{errors.email?.message}</p>
                  )}
                </CCol>
              </CRow>
              {/* <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="phone"
                    className="col-sm-3 col-form-label"
                  >
                    Phone:
                  </CFormLabel>
                  <CCol sm={8}>
                    <CFormInput
                      type="text"
                      id="phone"
                      {...register("phone")}
                    />
                    {errors.phone?.message && (
                      <p className="error_text">{errors.phone?.message}</p>
                    )}
                  </CCol>
                </CRow> */}
              {/* <hr/> */}
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="employeeCode"
                  className="col-sm-3 col-form-label"
                >
                  Employee Code:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="text"
                    id="employeeCode"
                    {...register("employeeCode")}
                  />
                  {errors.employeeCode?.message && (
                    <p className="error_text">{errors.employeeCode?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mt-5">
                <div className="d-flex justify-content-center">
                  <CButton type="submit" color="primary" className="px-5 py-2">
                    Submit
                  </CButton>
                </div>
              </CRow>
            </div>
          </div>
        </div>
      </div>
    </CForm>
  );
};

export default UserProfile;
